import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { useDispatch } from 'react-redux';
import { fetchRepsData } from '../../redux/slices/repSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SelectMultipleWrapper from '../../components/input/SelectMultiple';
import { productCategories } from '../../assets/data';

const Edit = ({ onClose, user }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const FORM_VALIDATION = Yup.object().shape({
        firstName: Yup.string().trim().required('Required'),
        lastName: Yup.string().required('Required'),
        email: Yup.string().email('Invalid email').required('Required'),
        phoneNo: Yup.number().typeError('Phone must be a number'),
        // .test('length', 'Input must be exactly 12 characters', (value) => value && value.toString().length === 12),
        area: Yup.string(),
        address: Yup.string()
    });

    const handleSubmit = async (values) => {
        try {
            const resp = await apiRequest('put', `users/${user?.id}`, values);

            if (resp?.data) {
                onClose();
                dispatch(fetchRepsData());
            }
        } catch (error) {
            toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    viewProductsCategory: user?.viewProductsCategory || [],
                    ...user
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    handleSubmit(values, resetForm);
                }}
            >
                <Form>
                    <Grid container direction="row" spacing={2}>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Textfield name="firstName" label="First Name" />
                        </Grid>

                        <Grid item lg={6} md={4} sm={6} xs={12}>
                            <Textfield name="lastName" label="Last Name" />
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Textfield name="email" label="Email" />
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Textfield name="phoneNo" label="Phone Number" />
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Textfield name="area" label="Area" />
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <SelectMultipleWrapper
                                defaultValue=""
                                name="viewProductsCategory"
                                label={'Product Category'}
                                options={productCategories}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={6} xs={12}>
                            <Textfield name="address" label="Address" />
                        </Grid>
                    </Grid>

                    <Box sx={styles.btnContainer}>
                        {loading ? (
                            <CircularProgress size={25} color="inherit" />
                        ) : (
                            <>
                                {/* -------------- onClick will call the onClose function that closes the History Modal */}
                                <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                    Cancel
                                </Button>

                                {/* -----------  change button title on the basis of history status */}
                                <Button type="submit" variant="text">
                                    Update
                                </Button>
                            </>
                        )}
                    </Box>
                </Form>
            </Formik>
        </div>
    );
};

export default memo(Edit);

const styles = {
    loadingContainer: {
        height: 400,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
